import { Directive, EventEmitter, ElementRef, Input, Output, SimpleChanges, Renderer2, OnChanges, AfterViewInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { NgControl } from '@angular/forms';
import { catchError } from 'rxjs/operators';

import { messages as i18n } from '@teem/constants/messages';

declare var $: any;
//
@Directive({
  selector: '[app-select2]',
  exportAs: 'select2Directive'
})
export class Select2Directive {
  select2: any;
  model: any;
  selected: any;

  @Input() placeholder: string;
  @Input() options: any;
  @Input() params: any;
  @Input() showAddNewItem: string;
  @Input() addNewItemTitle: string;

  @Input('selected')
  set setSelected(val: any) {

    this.selected = val;

    if (this.selected && this.selected.id && this.selected.text && $(this.el.nativeElement).hasClass('select2-hidden-accessible')) {
      const selectEl = $(this.el.nativeElement);

      // ✅ Check if option already exists
      let optionExists = selectEl.find(`option[value='${this.selected.id}']`).length;

      // ❗ If NOT exists → create it
      if (!optionExists) {
        const newOption = new Option(this.selected.text, this.selected.id, true, true);
        selectEl.append(newOption);
      }

      // ✅ Now trigger change properly
      selectEl.val(this.selected.id).trigger('change');
      
      // let params = this.selected;
      // params.manual_trigger = true;
      // $(this.el.nativeElement).select2("trigger", "change", {
      //   data: params
      // });
    }
  }

  @Output() itemSelected = new EventEmitter<boolean>();
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  constructor(
    protected httpClient: HttpClient,
    private el: ElementRef,
    private control?: NgControl) {
  }


  ngAfterViewInit(): void {
    if (this.options.lazyLoad) {
      this.createSelect2WithRemoteSource();
    } else {
      this.createSelect2();
    }

    this.bindJqueryEnvents();
	}

  ngOnChanges(changes: SimpleChanges) {

    if(changes.options && (changes.options.currentValue != changes.options.previousValue)) {
      if(this.options.data) {
        $(this.el.nativeElement).empty().append("<option></option>").trigger("change");
        this.createSelect2();
      }
    }
  }

  bindJqueryEnvents(): void {

    $(this.el.nativeElement).on('change', (event) => {
      if (this.control) {
        this.control.control.setValue($(this.el.nativeElement).select2("val"));
      } else if (this.model) {
        this.ngModelChange.emit($(this.el.nativeElement).select2("val"))
      }
    });

    $(this.el.nativeElement).on('select2:select', (event) => {
      const selectedItem = event.params.data;

      if (this.control) {
        this.control.control.setValue(selectedItem.id);
      } else if (this.model) {
        this.ngModelChange.emit(selectedItem.id)
      }

      if (!selectedItem.manual_trigger) {
        this.itemSelected.emit(selectedItem);
      }
    });

    var currentQuery;
    $(this.el.nativeElement).on('select2:open', (event) => {
      if (this.control)
        this.control.control.markAsTouched();

      setTimeout(function () {
        if (currentQuery && currentQuery.length) {
          $('.select2-search input').val(currentQuery).trigger('input');
        };
      }, 0);
    })
      .on('select2:closing', function () {
        currentQuery = $('.select2-search input').prop('value');
      });
  }

  getData(): Observable<any> {
    if (this.options.ajax) {
      let url = this.options.ajax.url;
      return this.httpClient.get(`${url}`).pipe(
        catchError((err: any) => {
          return throwError(err);
        })
      )
    } else {
      return of(this.options.data);
    }
  }

  createSelect2(): void {
    let select2Options: any = {
      // 'minimumInputLength': 3,
      allowClear: false,
      language: i18n.select2.messages()
    };

    if (this.placeholder) {
      select2Options.placeholder = this.placeholder;
    }

    if (this.options.tags) {
      select2Options.tags = this.options.tags;
    }

    if (this.options.dropdownParent) {
      select2Options.dropdownParent = $(this.options.dropdownParent).length ? $(this.options.dropdownParent) : null;
    }

    // if (this.options && this.options.ajax && this.options.ajax.url) {

    let idColumn = this.options.idColumn ? this.options.idColumn : 'id';
    let textColumn = this.options.textColumn ? this.options.textColumn : 'label';

    if (this.selected && this.selected.id && this.selected.text) {
      select2Options.initSelection = (element, callback) => {
        callback(this.selected);
      }
    }

    this.getData().subscribe(data => {
      // let data = r;
      if (data) {
        if (this.selected && this.selected.id && this.selected.text) {

          select2Options.initSelection = (element, callback) => {
            callback(this.selected);
          }
        }

        if (this.showAddNewItem == 'true') {
          let index = data.findIndex(x => x.id == "__add_new_items__");
          (index === -1) ? data.unshift({ id: '__add_new_items__', text: this.addNewItemTitle || 'Add New' }) : '';
        }

        let results = data.map(item => {
          if (item.id !== '__add_new_items__') {
            return {
              ...item,
              id: item[idColumn],
              text: item[textColumn]
            }
          } else {
            return item;
          }
        });

        select2Options.data = results;
        // $(this.el.nativeElement).select2('destroy');
        this.select2 = $(this.el.nativeElement).select2(select2Options);
        $(this.el.nativeElement).siblings('.select2-container').addClass('w-100');
      }
    }, (err) => {
      //
    })
    // }

    this.select2 = $(this.el.nativeElement).select2(select2Options);
    $(this.el.nativeElement).siblings('.select2-container').addClass('w-100');
  }

  createSelect2WithRemoteSource(): void {
    let select2Options: any = {
      'minimumInputLength': 3,
      language: i18n.select2.messages()
    };

    if (this.placeholder) {
      select2Options.placeholder = this.placeholder;
    }

    if (this.options.dropdownParent) {
      select2Options.dropdownParent = $(this.options.dropdownParent).length ? $(this.options.dropdownParent) : null;
    }

    if (this.selected && this.selected.id && this.selected.text) {
      select2Options.initSelection = (element, callback) => {
        callback(this.selected);
      }
    }

    if (this.options && this.options.ajax && this.options.ajax.url) {

      let idColumn = this.options.idColumn ? this.options.idColumn : 'id';
      let textColumn = this.options.textColumn ? this.options.textColumn : 'label';

      select2Options.ajax = {
        delay: 500,
        url: () => {
          if (this.params && this.params.stateId)
            return this.options.ajax.url + '?stateId=' + this.params.stateId;
          else
            return this.options.ajax.url;
        },
        data: function (args) {
          let data: any = { q: args.term };
          if (this.params && this.params.stateId) {
            data.stateId = this.params.stateId;
          }
          return data;
        },
        dataType: 'json',
        headers: {
          "Authorization": `Bearer ${(window as any).userInfo.api_token}`
        },
        processResults: function (data) {
          if (data) {
            if (this.showAddNewItem == 'true') {
              let index = data.findIndex(x => x.id == "__add_new_items__");
              (index === -1) ? data.unshift({ id: '__add_new_items__', text: this.addNewItemTitle || 'Add New' }) : '';
            }

            let results = data.map(item => {
              if (item.id !== '__add_new_items__') {
                return {
                  ...item,
                  id: item[idColumn],
                  text: item[textColumn]
                }
              } else {
                return item;
              }
            });
            return {
              results: results
            };
          }
        },
        cache: true
      }
    }

    this.select2 = $(this.el.nativeElement).select2(select2Options);
    $(this.el.nativeElement).siblings('.select2-container').addClass('w-100');
  }

  clear() {
    if (this.select2) {

      if (this.control) {
        this.control.control.setValue(null);
      } else if (this.model) {
        this.ngModelChange.emit(null);
      }

      $(this.el.nativeElement).trigger('change.select2');
    }
    $(this.el.nativeElement).select2("val", "");
  }
}
